let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("IEIly")).then(() => parcelRequire('71PFR'));